// import { createBrowserHistory } from 'history';
// import loggerMiddleware from 'redux-logger';
/* import {
  routerMiddleware,
} from 'connected-react-router'; */
import { thunk } from 'redux-thunk';
import {
  configureStore,
} from '@reduxjs/toolkit';
import createRootReducer from './redusers';

// export const history = createBrowserHistory();

const configureStoreLocal = () => {
  let store = {};

  if (process.env.DEBUG) {
    store = configureStore({
      reducer: createRootReducer(),
      middleware: () => {
        // WARNING: this means that _none_ of the default middleware are added!
        return [thunk,
          // loggerMiddleware, // расскоментирй для отладки
        ];
        // or for TS users, use:
        // return new Tuple(myMiddleware)
      },

      devTools: true,
    });
  } else {
    store = configureStore({
      reducer: createRootReducer(),
      middleware: () => {
        // WARNING: this means that _none_ of the default middleware are added!
        return [thunk,
          // loggerMiddleware, // расскоментирй для отладки
        ];
        // or for TS users, use:
        // return new Tuple(myMiddleware)
      },
      devTools: false,
    });
  }

  return store;
};

export const store = configureStoreLocal();

export default configureStoreLocal;
